import { Pipe, PipeTransform } from '@angular/core';

import * as moment from 'moment';

/*
 * Convert the date to relative time.
 * Usage:
 *   input | relativeTime
 * Example:
 *   {{ date | relativeTime }}
 *   formats to: 10 minutes ago
 */
@Pipe({ name: 'relativeTime' })
export class RelativeTimePipe implements PipeTransform {
  transform(input: Date): string {
    let output: string;
    let date: Date = new Date(input);

    // if date is less than 24 hours ago
    if (moment(date) >= moment().subtract(1, 'days')) {
      output = moment(date).fromNow();
    } else {
      // if date is greater than a year ago
      if (moment(date) >= moment().subtract(360, 'days')) {
        output = moment(date).format('MMMM DD @ h:mma');
      } else {
        output = moment(date).format('MMMM DD YYYY');
      }
    }

    return output;
  }
}
